import React, { Fragment } from 'react';

import TEXT from '../../../../../data/text.json';

import FormController from '../../form-components/form-controller';
import OverlayWrapper from '../../form-components/overlay-wrapper';
import FormWrapper from '../../form-components/form-wrapper';
import TextBox from '../../form-components/text-box';
import TextArea from '../../form-components/text-area';
import DropDown from '../../form-components/drop-down';
import RelatedItemsSelection from '../../form-components/related-items-selection';
import EmailInput from '../../form-components/email-input';
import ErrorMessage from '../../form-components/error-message';

export default class MemoryForm extends FormController {
  constructor(props) {
    super(
      props,
      [
        'nameValue',
        'emailValue',
        'memoryValue',
        'personTypeValue',
        'relatedItems'
      ],
      ['nameValue', 'emailValue', 'memoryValue'],
      3
    );
  }

  componentWillMount() {
    if (this.props.itemId && !this.props.recoveryState) {
      this.setRelatedItems([this.props.itemId]);
    }
  }

  render() {
    return (
      <OverlayWrapper
        title={TEXT.CONTRIBUTION_FORMS.ADD_MEMORY.title}
        subTitle={TEXT.CONTRIBUTION_FORMS.ADD_MEMORY.subTitle}
        footerProps={this.getFooterProps()}
        stages={[
          {
            name: 'Memory',
            active: this.state.stage === 1,
            onClick: () => this.setState({ stage: 1 })
          },
          {
            name: 'Related Items',
            active: this.state.stage === 2,
            onClick: () => this.setState({ stage: 2 })
          },
          {
            name: 'Finish',
            active: this.state.stage === 3,
            onClick: () => this.setState({ stage: 3 })
          }
        ]}
      >
        <FormWrapper>
          {this.state.stage === 1 && (
            <Fragment>
              <TextBox
                required
                id={TEXT.FORMS.nameId}
                label={TEXT.FORMS.nameLabel}
                placeholder={TEXT.FORMS.namePlaceholder}
                value={this.state.nameValue}
                onChange={this.setNameValue}
              />

              <DropDown
                id="personType"
                label="Your association with Whitefriars"
                selectedValue={this.state.personTypeValue}
                onChange={this.setPersonTypeValue}
                options={[
                  { text: 'Select your relation to Whitefriars...', value: '' },
                  { text: 'Staff', value: 'STAFF' },
                  { text: 'Collectors', value: 'COLLECTOR' },
                  { text: 'Staff Relatives', value: 'STAFF_RELATIVE' },
                  { text: 'Other', value: 'OTHER' }
                ]}
              />

              <TextArea
                required
                id={TEXT.FORMS.memoryId}
                label={TEXT.FORMS.memoryLabel}
                placeholder={TEXT.FORMS.memoryPlaceholder}
                value={this.state.memoryValue}
                onChange={this.setMemoryValue}
              />
            </Fragment>
          )}

          {this.state.stage === 2 && (
            <RelatedItemsSelection
              preselectedItemId={this.props.itemId}
              selectedItems={this.state.relatedItems}
              onChange={this.setRelatedItems}
            />
          )}

          {this.state.stage === 3 && (
            <Fragment>
              <EmailInput
                emailValue={this.state.emailValue}
                setEmailValue={this.setEmailValue}
              />

              {!this.state.formValid && (
                <ErrorMessage
                  title="Form not complete for submission"
                  message={this.validationMessage(this.state)}
                />
              )}
            </Fragment>
          )}
        </FormWrapper>
      </OverlayWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/contribution-form/forms/memory-form/index.js